// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import { Map } from 'immutable';

import './style.scss';
import Image from './Image';

class ImagePicker extends Component {
  constructor(props) {
    super(props);
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { images, selected, firstSelect, onPick } = this.props;
    this.state = {
      picked: Map(),
    };

    if (firstSelect) {
      this.state = {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        picked: Map().set(images[0].value, images[0].src),
      };
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      onPick({ src: images[0].src, value: images[0].value });
    }
    if (selected) {
      this.state = {
        picked: Map().set(
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          images.find(elem => elem.value === selected)?.value,
          selected
        ),
      };
    }
  }

  handleImageClick = image => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { picked } = this.state;
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { multiple, onPick } = this.props;
    const pickedImage = multiple ? picked : Map();
    let newerPickedImage = pickedImage.has(image.value)
      ? pickedImage.delete(image.value)
      : pickedImage.set(image.value, image.src);
    newerPickedImage = picked.has(image.value)
      ? newerPickedImage.delete(image.value)
      : newerPickedImage;

    this.setState({ picked: newerPickedImage });

    const pickedImageToArray = [];
    newerPickedImage.map((im, i) =>
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      pickedImageToArray.push({ src: im, value: i })
    );
    if (pickedImageToArray.length === 0) {
      onPick('');
      return;
    }
    onPick(multiple ? pickedImageToArray : pickedImageToArray[0]);
  };

  renderImage = (image, i) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { picked } = this.state;
    return (
      <Image
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        src={image.src}
        isSelected={picked.has(image.value)}
        onImageClick={() => this.handleImageClick(image)}
        key={i}
      />
    );
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { images } = this.props;
    return (
      <div className='image_picker'>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/prop-types */}
        {images.map(this.renderImage)}
        <div className='clear' />
      </div>
    );
  }
}

// ImagePicker.propTypes = {
//   images: PropTypes.array,
//   multiple: PropTypes.bool,
//   onPick: PropTypes.func,
// };

export default ImagePicker;
